import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Button } from 'foundations-components/transitional/components/Button';
import { View } from 'foundations-components/transitional/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import AppLogo from './AppLogo';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Header = ({
  hideBackToLogin = false
}) => {
  return /*#__PURE__*/_jsx(View, {
    as: "header",
    display: "block",
    marginInline: "1400",
    children: /*#__PURE__*/_jsxs(TFlex, {
      justify: "between",
      align: "center",
      children: [/*#__PURE__*/_jsx(AppLogo, {
        logoWidth: "140px",
        logoAlignment: "center",
        logoPadding: "400"
      }), !hideBackToLogin && /*#__PURE__*/_jsx(Button, {
        href: "/login",
        use: "transparent",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "loginV4.backToLogin"
        })
      })]
    })
  });
};